import { Reducer } from "../../alias";
import { Validation } from "../../lib";
import { buildReducerWithUndo } from "./ReducerWithUndo";

export type GameCommandByPlayer<GameCommand> = GameCommand & {
  playerId: string;
};

export type GameReducerFactoryProps<Game, GameCommand> = {
  copyGame: (game: Game) => Game;
  applyCommand: (game: Game, command: GameCommandByPlayer<GameCommand>) => void;
  isValidCommand?: (
    game: Game,
    command: GameCommandByPlayer<GameCommand>
  ) => Validation;
};

// TODO handle info events in this factory.
export const gameReducerFactory = <Game, GameCommand>({
  copyGame,
  applyCommand,
  isValidCommand,
}: GameReducerFactoryProps<Game, GameCommand>) => {
  const gameReducer: Reducer<Game, GameCommandByPlayer<GameCommand>> = (
    game: Game,
    command: GameCommandByPlayer<GameCommand>
  ) => {
    const errorOpt = isValidCommand?.(game, command);
    if (errorOpt) {
      console.warn(
        "ignoring impossible command",
        command,
        ". Reason:",
        errorOpt
      );
      return game;
    }
    const newGame = copyGame(game);
    console.info("applying command", command);
    applyCommand(newGame, command);
    return newGame;
  };

  const gameReducerWithUndo = buildReducerWithUndo(gameReducer);

  return { gameReducer, gameReducerWithUndo };
};
